import {
  TeamDomainQueryModelSchema,
  TeamDomainUpdateModelSchema,
  UserIdSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { GetTeamOutputSchema } from './get-team.models.ts'

export const UpdateTeamInputSchema = TeamDomainQueryModelSchema.pick({
  teamId: true,
  organizationId: true,
  avatarFileId: true,
  billingProfileId: true,
})
  .extend({
    userIds: UserIdSchema.array().optional(),
  })
  .extend(
    TeamDomainUpdateModelSchema.pick({
      name: true,
    }).shape
  )

export type UpdateTeamInput = ZodInfer<typeof UpdateTeamInputSchema>

export const UpdateTeamOutputSchema = GetTeamOutputSchema

export type UpdateTeamOutput = ZodInfer<typeof UpdateTeamOutputSchema>
